module.exports = __webpack_public_path__ + "img/BLCA_NK.9ce75e29.png";